module.exports = __webpack_public_path__ + "static/media/helvetica-bold-font-webfont.598b8f1b.woff2";